import React from 'react';
import { Box, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

const Wrapper = styled(Box)`
  &:hover {
    color: ${({ theme }) => theme.colors.textAccent};
    background-color: ${({ theme }) => theme.colors.accentContainer};
  }
`;

const AddNewTriggerTitle = () => (
  <Wrapper fill align="start" round="dropdownItemRound">
    <Text size="medium" weight="normal" color="textAccent">
      Add New Trigger
    </Text>
  </Wrapper>
);

export default AddNewTriggerTitle;
